import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';

const getScrollContainer = (element: HTMLElement): HTMLElement | null => {
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    if (/auto|scroll/.test(getComputedStyle(parent).getPropertyValue('overflow-y'))) {
      return parent;
    }
  }

  return null;
};

// Swapping the slides of a dialog resizes it at once, while the leaving slide lingers for the whole transition: a scroll
// offset kept from the previous step would show that slide outside of the dialog until it is removed.
// TODO(taiga): drop this directive once `tuiSlides` does not leave the leaving slide at its previous scroll offset.
@Directive({
  selector: '[pxcSlidesScrollReset]',
})
export class SlidesScrollResetDirective implements OnInit, OnDestroy {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

  private readonly slidesObserver = new MutationObserver(() => {
    const scrollContainer = getScrollContainer(this.element);

    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  });

  ngOnInit(): void {
    this.slidesObserver.observe(this.element, { childList: true });
  }

  ngOnDestroy(): void {
    this.slidesObserver.disconnect();
  }
}
